import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";

export const CenterCard = ({ center, index = 0 }) => {
    const cover = center.photos?.[0] || "https://images.pexels.com/photos/7651627/pexels-photo-7651627.jpeg";
    return (
        <Link
            to={`/centers/${center.center_id}`}
            data-testid={`center-card-${center.center_id}`}
            className="group block border border-zinc-200 bg-white reveal"
            style={{ animationDelay: `${index * 0.05}s` }}
        >
            <div className="aspect-[4/3] overflow-hidden bg-zinc-100 relative">
                <img
                    src={cover}
                    alt={center.name}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 bg-white/90 backdrop-blur px-2 py-1 text-[10px] uppercase tracking-label">
                    {center.city}
                </div>
            </div>
            <div className="p-5">
                <div className="flex items-start justify-between gap-3">
                    <div>
                        <h3 className="font-display text-xl font-semibold tracking-tight leading-tight">{center.name}</h3>
                        <div className="mt-1 flex items-center gap-1.5 text-xs text-zinc-600">
                            <MapPin className="h-3.5 w-3.5" strokeWidth={1.5} />
                            {center.public_area}
                        </div>
                    </div>
                    <ArrowUpRight className="h-5 w-5 text-zinc-400 group-hover:text-zinc-950 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" strokeWidth={1.5} />
                </div>
                <p className="mt-3 text-sm text-zinc-600 line-clamp-2">{center.description}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                    {(center.amenities || []).slice(0, 3).map((a) => (
                        <span key={a} className="text-[10px] uppercase tracking-label bg-zinc-100 text-zinc-800 px-2 py-1">{a}</span>
                    ))}
                </div>
            </div>
        </Link>
    );
};

export default CenterCard;
